import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../rtk/slices/products-slice.js";
import { useEffect } from "react";

function ProductsFetch () {

  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.products);

  // useEffect لجلب بيانات الكتالوج عند تحميل المكون لأول مرة
  useEffect(() => {
    // إذا كان الـ status في حالة 'idle' (لم يبدأ الجلب بعد)، ابدأ الجلب
    // dispatch(fetchProducts());

  }, [dispatch]); // التابعيات: dispatch و status لضمان الجلب مرة واحدة


  console.log(products);

  return (
    <div>

    </div>
  )
}

export default ProductsFetch


export let products = [
  {
    id: 1,
    title: {
      en: "Modern Sectional Sofa",
      ar: "أريكة عصرية متعددة الأقسام",
      fr: "Canapé Sectionnel Moderne"
    },
    category: 1,
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&h=600&fit=crop",
    price: "$2,499",
    description: {
      en: "Luxurious sectional sofa with premium fabric upholstery and ergonomic design. Perfect for modern living spaces.",
      ar: "أريكة فاخرة متعددة الأقسام مع تنجيد قماش مميز وتصميم مريح. مثالية للمساحات العصرية.",
      fr: "Canapé sectionnel luxueux avec tapisserie en tissu premium et design ergonomique. Parfait pour les espaces de vie modernes."
    },
    specifications: {
      en: ["Dimensions: 120\" x 80\" x 35\"", "Material: Premium Fabric", "Color: Charcoal Gray", "Warranty: 5 Years"],
      ar: ["الأبعاد: 305 × 203 × 89 سم", "المادة: قماش مميز", "اللون: رمادي فحمي", "الضمان: 5 سنوات"],
      fr: ["Dimensions: 305 x 203 x 89 cm", "Matériau: Tissu Premium", "Couleur: Gris Anthracite", "Garantie: 5 Ans"]
    }
  }
];

export const getProductsByCategory = (category) => {
  return products.filter(product => product.category === category);
};

export const getProductById = (id) => {
  return products.find(product => product.id === id);
};